/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./res-list-handler.vue?vue&type=template&id=04b14baf&scoped=true&"
import script from "./res-list-handler.vue?vue&type=script&lang=js&"
export * from "./res-list-handler.vue?vue&type=script&lang=js&"
import style0 from "./res-list-handler.vue?vue&type=style&index=0&id=04b14baf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b14baf",
  null
  
)

export default component.exports